import React from 'react';

import MenuList from 'components/MenuList';
import MenuListItem from 'components/MenuList/MenuListItem';
import Tooltip from 'components/Tooltips/Tooltip';
import { Divider } from 'components/TripCard/styles';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { TravelDetails } from 'models/travelDetails';

import { Title, Message, MessageBold, InfoCircleIcon } from '../styles';
import { UserCheckIcon } from './styles';

type Props = {
  travelDetails: TravelDetails;
  setHelp(type: string): void;
};

const Pending = ({ travelDetails, setHelp }: Props) => {
  const { t } = useStoreTranslation();
  const { numberOfApprovers, numberOfExpectedApprovers } = travelDetails;

  const helpItems = [
    {
      label: t('customerSupport.cancelRequest.title'),
      onClick() {
        setHelp(travelDetails.requester.status === 'Pending' ? 'cancelPending' : 'cancelConfirmed');
      },
    },
    {
      label: t('customerSupport.changeRequest.title'),
      onClick() {
        setHelp(travelDetails.requester.status === 'Pending' ? 'changePending' : 'changeConfirmed');
      },
    },
  ];

  return (
    <>
      <UserCheckIcon />
      <Title>{t('customerSupport.pendingRequest.title')}</Title>
      <Message>
        {t('customerSupport.pendingRequest.approvedBy')} <MessageBold>{numberOfApprovers}</MessageBold>{' '}
        {t('customerSupport.pendingRequest.of', { count: numberOfExpectedApprovers })}
        <Tooltip
          event="hover"
          content={t('customerSupport.pendingRequest.tooltip', { count: numberOfExpectedApprovers })}
        >
          <InfoCircleIcon />
        </Tooltip>
      </Message>

      <Divider />

      <MenuList embedded>
        {helpItems.map(({ label, onClick }) => (
          <MenuListItem key={label} onClick={onClick} label={label} />
        ))}
      </MenuList>
    </>
  );
};

export default Pending;
